/** `data-live-tour-target` values the host tour points at; mirrored in the PWA. */
const LIVE_TOUR_TARGETS = {
    EXPERIENCE_SCORE: 'EXPERIENCE_SCORE',
    TIPS_TO_CONSIDER: 'TIPS_TO_CONSIDER',
    EXPERIENCE_INSIGHTS: 'EXPERIENCE_INSIGHTS',
} as const;

export default LIVE_TOUR_TARGETS;
